import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

export const EventFormStepContact = () => {
  return (
    <GridWrapper>
      <Grid item xs={12}>
        <Typography variant='body1' sx={{ fontWeight: 600, mb: -1 }}>
          {t('event:formFields.contact')}
        </Typography>
      </Grid>
      <Grid item xs={12} lg={4}>
        <ControlledTextField
          name='contactPersonName'
          label={t('event:formFields.contactPersonName')}
          inputProps={{ maxLength: 100 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <ControlledTextField
          name='contactPersonEmail'
          label={t('event:formFields.contactPersonEmail')}
          inputProps={{ maxLength: 320 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} lg={4} mb={1.5}>
        <ControlledTextField
          name='contactPersonPhone'
          label={t('event:formFields.contactPersonPhone')}
          inputProps={{ maxLength: 20 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </GridWrapper>
  );
};
